import { jsx, Fragment } from "react/jsx-runtime";
import { memo, useEffect } from "react";
import { connect } from "react-redux";
import { selectIsTopBluemFlowEnabled } from "@nxplatform/platform-settings/registration-settings.slice";
import { bodyLoaderClass, bodyAppReadyClass } from "../../facades/route-switcher/app-setup.facade.js";
import "@nxplatform/bonuses/entities/common-entities";
import "@nxplatform/customer-noauth/slices/text-pages.slice";
import "@nxplatform/helpers/helpers-pure";
import "@nxplatform/platform-entities/customer/customer-enum-types";
import "@nxplatform/platform-settings/locale-setup.routes";
import "@nxplatform/platform-settings/locale-setup.selectors";
import "@nxplatform/store-shared/customer/shared-customer-selectors";
import "react-router";
import "@nxplatform/helpers/helpers";
import "@nxplatform/customer-cashier/hooks/open-cashier-modal.hook";
import "@nxplatform/platform-entities";
import "@nxplatform/platform-settings/brand-settings.slice";
import "@nxplatform/store-utils/module-manager/module-manager.slice";
import "rxjs";
import "@nxplatform/helpers/dev-features";
import "@nxplatform/helpers/timings";
import "@service/api-client/token/token-action";
import "@nxplatform/helpers/common";
import "@nxplatform/customer-noauth/slices/customer-token.slice";
import "@nxplatform/store-shared/customer/shared-customer-actions";
import "../../common/seon-device-fingerprint/seon-device-fingerprint.slice.js";
import "@nxplatform/store-shared/sport/shared-sport-actions";
import "@service/api-client/websockets/centrifuge";
import "@nxplatform/customer/slices/customer.slice";
import "@service/api-client/slices";
import "@service/api-client/websockets/ws-clients";
const RegistrationPageWrapper = ({
  RegistrationPage,
  topBluemRegistrationEnabled
}) => {
  useEffect(() => {
    var _a, _b;
    if (topBluemRegistrationEnabled) return;
    document.body.classList.remove(bodyLoaderClass);
    (_a = document.getElementById("app-loader")) == null ? void 0 : _a.remove();
    (_b = document.getElementById("load_content")) == null ? void 0 : _b.remove();
    document.body.classList.add(bodyAppReadyClass);
  }, [topBluemRegistrationEnabled]);
  return /* @__PURE__ */ jsx(Fragment, { children: !topBluemRegistrationEnabled && /* @__PURE__ */ jsx(RegistrationPage, {}) });
};
const mapStateToProps = (state) => ({
  topBluemRegistrationEnabled: selectIsTopBluemFlowEnabled(state)
});
const _RegistrationPageWrapper = connect(
  mapStateToProps
)(memo(RegistrationPageWrapper));
export {
  _RegistrationPageWrapper as RegistrationPageWrapper
};
